import { uuidv7 } from "@ets/shared";
import { COOKIE_NAMES, TTL } from "@ets/types";
import type { CookieOptions } from "./cookie.js";
import { getPersistedValue, setPersistedValue } from "./storage.js";

const VID_COOKIE_OPTIONS: CookieOptions = {
  maxAge: TTL.VISITOR_ID_SECONDS,
  sameSite: "Lax",
  secure: true,
};

/**
 * Resolve the visitor ID:
 * 1. Read from cookie ets_vid
 * 2. Fallback to localStorage (re-persist to cookie)
 * 3. Generate new UUID v7 and persist
 */
export function resolveVisitorId(): string {
  const existing = getPersistedValue(COOKIE_NAMES.VISITOR_ID, VID_COOKIE_OPTIONS);
  if (existing) return existing;

  const newId = uuidv7();
  setPersistedValue(COOKIE_NAMES.VISITOR_ID, newId, VID_COOKIE_OPTIONS);
  return newId;
}
